<template>
    <div class="page_container">
        <div class="page-filter_wrap">
            <div class="page-filter_wrap_left">
                <el-input v-model="searchForm.keyword"
                          class="filter-input"
                          ref="search_input"
                          clearable
                          placeholder="请输入您想搜索的内容"
                          @clear="handleClickSearch"
                          @blur="handleClickSearch"
                          @keyup.enter.native="handleClickSearch">
                    <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                </el-input>
                <ListAdvancedFiltering :field_form="'purchases'"
                                       :field_list="formInfoList"
                                       :system_fields="systemFilterFields"
                                       @sendFilterData="getFilterData"/>
            </div>
            <div class="page-filter_wrap_right flex_wrap">
                <el-button type="primary" @click="handleClickAddPurchase">新建采购</el-button>
            </div>
        </div>
        <div class="page_table_content">
            <CustomVxeTable
                    :loading="loading"
                    id="customTable1"
                    ref="customTable"
                    :class="{ 'custom-table': filterCount }"
                    :customConfig="tableCustomConfig"
                    :empty-render="{ name: 'NotData' }"
                    :isShowToolBar="true"
                    :pagination.sync="pagination"
                    :reduceHeight="reduceHeight"
                    :tableData="tableData"
                    @handleCurrentChange="handleCurrentChange"
                    @handleSizeChange="handleSizeChange"
            >
                <vxe-column v-for="field in formInfoList"
                            :key="field.field_key"
                            :align="field.align?'right':'left'"
                            :field="field.field_key"
                            :title="field.field_name"
                            :fixed="field.field_key==='purchase_num'?'left':''"
                            show-overflow
                            :width="field.field_type == 'paying_teller' || field.field_type == 'invoice' ?  200: 150">
                    <template #default="{ row }">
                        <div v-if="field.field_key==='purchase_num'"
                             class="link-label"
                             @click.stop="handleClickPurchaseDetail(row)">
                            <span v-if="row.purchase_num" v-text="row.purchase_num"></span>
                        </div>
                        <div v-else-if="field.field_key==='userinfo'">
                            <div  class="custom_contact_field_wrap">
                                <PersonnelCard :userId="row[field.field_key].uid" v-if="row[field.field_key].uid">
                                    <template slot="container">
                                        <img :src="row[field.field_key].avatar?row[field.field_key].avatar:defaultImg" alt="" class="avatar">
                                        <span class="name" v-text="row[field.field_key].name"></span>
                                    </template>
                                </PersonnelCard>
                            </div>
                        </div>
                        <div v-else-if="field.field_key==='status'">
                            <span class="status_code status_code0"  v-if="row.status == 0 ">审批中</span>
                            <span class="status_code status_code1"  v-if="row.status == 1 ">已通过</span>
                            <span class="status_code status_code2"  v-if="row.status == 2 ">已拒绝</span>
                            <span class="status_code status_code3"  v-if="row.status == 3 ">已撤销</span>
                            <span class="status_code status_code4"  v-if="row.status == 4 ">部分退货</span>
                            <span class="status_code status_code5"  v-if="row.status == 5 ">全部退货</span>
                        </div>
                        <div v-else>
                            <div v-if="field.field_type==='contact'">
                                <div v-if="row[field.field_key].length">
                                    <div v-for="item in row[field.field_key]"
                                         class="custom_contact_field_wrap">
                                        <PersonnelCard :userId="item.id" v-if="item.id">
                                            <template slot="container">
                                                <img :src="item.avatar?item.avatar:defaultImg" alt=""
                                                     class="avatar">
                                                <span class="name" v-text="item.name"></span>
                                            </template>
                                        </PersonnelCard>
                                    </div>
                                </div>
                                <span v-else>--</span>
                            </div>
                            <div v-else-if="field.field_type==='department'">
                                <div v-if="row[field.field_key].length">
                                    <span v-text="row[field.field_key].map(map => map.department_name).join('、')"></span>
                                </div>
                                <span v-else>--</span>
                            </div>
                            <div v-else-if="field.field_type==='radio'">
                                    <span v-if="row[field.field_key]"
                                          :class="{'is_tag_interaction':field.extend.tag_interaction}"
                                          v-text="row[field.field_key]"></span>
                                <span v-else>--</span>
                            </div>
                            <div v-else-if="field.field_type==='checkbox'">
                                <div v-if="row[field.field_key].length" class="custom_checkbox_field_wrap">
                                        <span v-for="item in row[field.field_key]"
                                              :class="{'is_tag_interaction':field.extend.tag_interaction}"
                                              v-text="item">
                                        </span>
                                </div>
                                <span v-else>--</span>
                            </div>
                            <div v-else-if="field.field_type==='checkbox_user_tag'">
                                <div v-if="row[field.field_key].length" class="custom_checkbox_field_wrap">
                                        <span v-for="item in row[field.field_key]"
                                              class="is_tag_interaction"
                                              v-text="item.name">
                                        </span>
                                </div>
                                <span v-else>--</span>
                            </div>
                            <div v-else-if="field.field_type==='image'">
                                <div v-if="row[field.field_key].length" class="table_custom_image_wrap">
                                    <el-image
                                            :preview-src-list="row[field.field_key].map(img=>img.file_path)"
                                            :src="row[field.field_key][0].file_path"
                                            fit="cover">
                                    </el-image>
                                    <el-popover :visible-arrow="false"
                                                placement="bottom-start"
                                                popper-class="table_custom_image_popover"
                                                title=""
                                                trigger="hover"
                                                width="254">
                                        <div slot="reference">
                                                <span v-if="row[field.field_key].length>1"
                                                      class="image_count"
                                                      v-text="`+${row[field.field_key].length-1}`"></span>
                                        </div>
                                        <ul class="image_list">
                                            <li v-for="(img,img_index) in row[field.field_key]"
                                                :key="img_index"
                                                class="image_item">
                                                <el-image
                                                        :preview-src-list="row[field.field_key].map(img=>img.file_path)"
                                                        :src="img.file_path"
                                                        fit="cover">
                                                </el-image>
                                            </li>
                                        </ul>
                                    </el-popover>
                                </div>
                                <span v-else>--</span>
                            </div>
                            <div v-else-if="field.field_type==='file'">
                                <div v-if="row[field.field_key].length"></div>
                                <span v-else>--</span>
                            </div>
                            <div v-else-if="field.field_type==='invoice'">
                                <div v-if="row[field.field_key].length"></div>
                                <span v-else>--</span>
                            </div>
                            <div v-else-if="field.field_type==='relate_approve_form'"></div>
                            <div v-else-if="field.field_type==='id_card'">
                                <div v-if="row[field.field_key].value" class="custom_id_card_field_wrap">
                                    <span v-text="row[field.field_key].value"></span>
                                    <el-popover placement="bottom"
                                                popper-class="id_card_detail_popper"
                                                trigger="click"
                                                width="350">
                                            <span slot="reference" class="handle_icon_wrap">
                                                 <i class="iconfont icon-shenfenzheng"></i>
                                            </span>
                                        <el-form size="small">
                                            <el-form-item v-if="row[field.field_key].name" label="姓名"
                                                          prop="name">
                                                <span v-text="row[field.field_key].name"></span>
                                            </el-form-item>
                                            <el-form-item v-if="row[field.field_key].birthday" label="出生日期"
                                                          prop="birthday">
                                                <span v-text="row[field.field_key].birthday"></span>
                                            </el-form-item>
                                            <el-form-item v-if="row[field.field_key].address" label="家庭住址"
                                                          prop="name">
                                                <span v-text="row[field.field_key].address"></span>
                                            </el-form-item>
                                            <el-form-item label="身份证号" prop="value">
                                                <span v-text="row[field.field_key].value"></span>
                                            </el-form-item>
                                        </el-form>
                                        <img alt=""
                                             class="ic_card_icon"
                                             src="https://download.hecoos.com/enlightv/2024-48/2d35b952fcb868047612cca8bf82a615.png">
                                    </el-popover>
                                </div>
                                <span v-else>--</span>
                            </div>
                            <div v-else-if="field.field_type==='paying_teller'">
                                <div v-if="row[field.field_key]&&row[field.field_key].text"
                                     class="custom_paying_teller_field_wrap">
                                    <span v-text="row[field.field_key].text"></span>
                                    <el-popover placement="bottom"
                                                popper-class="paying_teller_detail_popper"
                                                trigger="click"
                                                width="350">
                                            <span slot="reference" class="handle_icon_wrap">
                                                 <i class="iconfont icon-zhanghu"></i>
                                            </span>
                                        <el-form class="custom_detail_form" label-position="top"
                                                 size="small">
                                            <el-form-item label="账户类型" prop="account_type">
                                                <span v-text="row[field.field_key].account_type===1?'个人账户':'对公账户'"></span>
                                            </el-form-item>
                                            <el-form-item label="户名" prop="account_name">
                                                <span v-text="row[field.field_key].account_name"></span>
                                            </el-form-item>
                                            <el-form-item label="账号" prop="card_number">
                                                <span v-text="row[field.field_key].text"></span>
                                            </el-form-item>
                                            <el-form-item label="所属银行" prop="bank_name">
                                                <span v-text="row[field.field_key].bank_name"></span>
                                            </el-form-item>
                                            <el-form-item v-if="field.extend.bank_branch_is_show"
                                                          label="银行支行"
                                                          prop="bank_branch">
                                                <span v-text="row[field.field_key].bank_branch"></span>
                                            </el-form-item>
                                        </el-form>
                                    </el-popover>
                                </div>
                                <span v-else>--</span>
                            </div>
                            <div v-else-if="field.field_type==='table'">
                            </div>
                            <div v-else-if="field.field_type==='system'">
                                <span   v-text="row[field.field_key]?row[field.field_key]:'--'"></span>
                            </div>
                            <div v-else-if="field.field_type==='purchase_details'">
                                <span class="link-label"   @click.stop="handleClickPurchaseDetail(row)">查看采购明细</span>
                            </div>


                            <div v-else>
                                <span   v-text="row[field.field_key]?row[field.field_key]:'--'"></span>
                            </div>
                        </div>
                    </template>
                </vxe-column>
                <vxe-column field="operate" fixed="right" width="90">
                    <template #header>
                        <span>操作</span>
                        <el-tooltip class="item"
                                    content="表头设置"
                                    effect="dark"
                                    placement="bottom-start">
                            <i class="iconfont icon-biaotoushezhi table-header-icon"
                               @click="handleClickCustom"></i>
                        </el-tooltip>
                    </template>
                    <template #default="{ row }">
                        <div class="table-operate-icon">
                            <el-dropdown placement="bottom-end" trigger="click">
                                <el-tooltip content="更多" effect="dark" placement="top">
                                    <i class="iconfont el-icon-more"></i>
                                </el-tooltip>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-if="row.status == 0" @click.native="handleClickWithdrawApproval(row)">撤销审批</el-dropdown-item>
                                    <el-dropdown-item v-if="row.status == 2 || row.status == 3" @click.native="handleClickRestart(row)">重新发起</el-dropdown-item>
                                    <el-dropdown-item v-if="row.status == 1 || row.status == 4" @click.native="handleClickReturnGoods(row)">退货</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleClickPurchaseDetail(row)">详情</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </template>
                </vxe-column>
            </CustomVxeTable>
        </div>
        <PurchaseAdd :purchaseAddVisible.sync="purchaseAddVisible" v-if="purchaseAddVisible" @success="handleClickSearch"/>
        <PurchaseEdit :purchaseEditVisible.sync="purchaseEditVisible" v-if="purchaseEditVisible" :purchaseId="purchaseId"  @success="handleClickSearch"/>
        <PurchaseDetail :purchaseDetailVisible.sync="purchaseDetailVisible" v-if="purchaseDetailVisible" :purchaseId="purchaseId"/>
        <PurchaseReturnGoods :purchaseReturnGoodsVisible.sync="purchaseReturnGoodsVisible" v-if="purchaseReturnGoodsVisible" :purchaseId="purchaseId"  @success="handleClickSearch"/>
    </div>
</template>
<script>
import {pagination} from '@/mixins'
import CustomVxeTable from "@/components/pComponents/vxe-table";
import ListAdvancedFiltering from "@/components/pComponents/ListAdvancedFiltering";
import PersonnelCard from "@/components/pComponents/PersonnelCard";
import { getFormFields,PurchaseList,cancelApproval} from "@/api";
import {tableDataFieldShow} from "@/utils";
import PurchaseAdd from "./component/purchase_add";
import PurchaseEdit from "./component/purchase_edit";
import PurchaseDetail from "./component/purchase_detail";
import PurchaseReturnGoods from "./component/purchase_returnGoods";
export default {
    name: "Purchase",
    mixins: [pagination],
    components: {
        CustomVxeTable,
        PersonnelCard,
        ListAdvancedFiltering,
        PurchaseAdd,
        PurchaseDetail,
        PurchaseReturnGoods,
        PurchaseEdit
    },
    data() {
        return {
            loading:false,
            defaultImg: require('@/assets/images/default.jpg'),
            tableData:[],
            filterCount: 0,
            searchForm:{
                keyword: '',
            },
            formInfoList:[],
            systemFilterFields: [
                {
                    field_type: "date_range",
                    field_key: "purchases.pre_due_date",
                    is_system: 1,
                    date_type:'daterange',
                    field_name: "创建时间",
                    system_type: "system",
                    field_value_type: "array",
                },
                {
                    field_type: "radio",
                    field_key: "purchases.status",
                    is_system: 1,
                    field_name: "单据状态",
                    system_type: "system",
                    field_value_type: "int",
                    options: [
                        { value: 0, label: "审批中" },
                        { value: 1, label: "已通过" },
                        { value: 2, label: "已拒绝" },
                        { value: 3, label: "已撤销" },
                        { value: 4, label: "部分退货" },
                        { value: 5, label: "全部退货" },
                    ],
                },
            ], //单据状态筛选/预交日期筛选/发起人

            purchaseAddVisible:false,
            purchaseEditVisible:false,
            tableCustomConfig: {
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return true;
                },
                checkMethod: (col) => {
                    return true
                },
                allowSort: true,
            },
            purchaseDetailVisible:false,
            purchaseId:0,
            purchaseReturnGoodsVisible:false
        }
    },
    created() {
        this._getFromFields()
    },
    computed: {
        reduceHeight() {
            return this.filterCount ? 160 : 170
        }
    },
    mounted() {

    },
    methods: {
        //获取自定义字段列表
        _getFromFields() {
            this.loading = true
            getFormFields({
                field_form: 'purchases',
                filter_field_type: ''
            }).then(res => {
                if (res.code === 200) {
                    this.formInfoList = res.data
                    let add_forms = [
                        {field_key: "purchase_num",field_name: "采购单编号"},
                        {field_key: "userinfo",field_name: "发起人"},
                        {field_key: "status",field_name: "单据状态"},
                    ]
                    this.formInfoList.splice(0, 0, ...add_forms);
                    this.getTableData()
                } else {
                    this.loading = false
                    this.$message.error(res.message)
                }

            }).catch(() => {

            })
        },
        // 新建采购
        handleClickAddPurchase(){
            this.purchaseId = 0
            this.purchaseAddVisible = true
        },
        // 筛选
        handleClickSearch(){
            this.pagination.pageNum = 1;
            this.getTableData();
        },
        // 获取筛选数据
        getFilterData(data) {
            this.custom_filter = data;
            this.handleClickSearch()
        },

        // 表头配置
        handleClickCustom() {
            this.$refs.customTable.handleOpenCustomShow();
        },

        // 页码改变
        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            this.getTableData();
        },
        // 页数改变
        handleSizeChange(page) {
            this.pagination.pageNum = 1;
            this.pagination.pageSize = page.pageSize;
            this.getTableData();
        },
        getTableData(){
            this.loading = true
            PurchaseList({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
                custom_filter: this.custom_filter
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.tableData = data
                    this.pagination.total = total
                    tableDataFieldShow(this.formInfoList, this.tableData)
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            })
        },
        // 查看详情
        handleClickPurchaseDetail(row){
            this.purchaseId = row.purchase_id
            this.purchaseDetailVisible = true
        },
        // 撤回审批
        handleClickWithdrawApproval(row){
            console.log(row);
            const h = this.$createElement;
            this.$msgbox({
                title: '审批撤销',
                message: h('div', null, [
                    h('span', null, '请谨慎操作，是否继续撤销？'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: 'prompt_message_custom',
                confirmButtonText:  '是',
                cancelButtonText:  '否',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass:  '',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                cancelApproval({approval_id:row.approval_id}).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            message: '撤销成功',
                            type: 'success',
                            duration: 1000,
                            onClose: () => { }
                        })
                        this.getTableData()
                    }
                })
            }).catch(() => {

            })
        },
        // 重新发起
        handleClickRestart(row){
            this.purchaseId = row.purchase_id
            this.purchaseEditVisible = true
        },
        // 退货
        handleClickReturnGoods(row){
            this.purchaseId = row.purchase_id
            this.purchaseReturnGoodsVisible = true
        },
    },
}
</script>
<style lang="scss" scoped>
    .page_container{
        padding: 16px;
        box-sizing: border-box;
    }
    .status_code{
        padding-left: 10px;
        position: relative;
        color: rgb(102, 102, 102);
        font-size: 14px;
        &:before{
            width: 6px;
            height: 6px;
            border-radius: 50%;
            position: absolute;
            left: 0;
            top: 7px;
            content: ' ';
        }
        &.status_code0:before{
            background: rgba(240, 170, 50, 1);
        }
        &.status_code1:before{
            background: rgba(90, 179, 51, 1);
        }
        &.status_code2:before{
            background: rgba(228, 65, 68, 1);
        }
        &.status_code3:before{
            background: rgba(153, 153, 153, 1);
        }
        &.status_code4:before{
            background: rgba(240, 120, 50, 1);
        }
        &.status_code5:before{
            background: rgba(255, 190, 153, 1);
        }


    }
</style>

